import {RouteEntry} from "../../shared/routes";
import {History} from "./History";

export const historyRoutes: Array<RouteEntry> = [
    { path: '/history/:id', component: History },
    { path: '/history', component: History },
];
